import _cloneDeep from "lodash/cloneDeep";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Price } from 'swag-client-common/utils/price';
import { checkIsCustomInkTenant } from 'swag-common/utils/check-is-custom-ink-tenant.util';
import { getItemPriceMultiplier } from 'swag-common/business-logic/get-item-price-multiplier.logic';
import { discardMultiplierToProduct } from 'swag-common/utils/tenant-price-settings';
import { getStoreSettings } from 'swag-client-common/utils/get-store-settings';
export function getItemPriceFromProduct({
  orderItem,
  product,
  blendedQuantity,
  screenPrice,
  totalQuantityForSharedItems,
  discardMultiplier,
  featureFlags
}) {
  const storeSettings = getStoreSettings();
  const {
    tenant
  } = window.swag;
  if (checkIsCustomInkTenant(tenant)) {
    const price = Price.getPrice({
      orderItem,
      product,
      blendedQuantity,
      screenPrice,
      totalQuantityForSharedItems,
      featureFlags
    });
    return price;
  }
  const multiplier = getItemPriceMultiplier(orderItem) || storeSettings.storePricesMultiplier;
  let productToUse = product;
  if (discardMultiplier) {
    productToUse = discardMultiplierToProduct(_cloneDeep(product), multiplier);
  }
  const price = Price.getPrice({
    orderItem: _objectSpread({}, orderItem, {
      prod: productToUse
    }),
    product: productToUse,
    blendedQuantity,
    screenPrice,
    totalQuantityForSharedItems,
    multiplier,
    featureFlags
  });
  return price;
}